import "./Checkbox.scss";

/**
 * 自定义勾选框。
 * 项目全局 reset.scss 里 `input[type=checkbox]{appearance:none}` 会让原生勾选框
 * 不可见，这里用一个受控的方块 + 对勾 SVG 自绘，规避该全局重置。
 * 尺寸走 scss（px→rem），随整页等比缩放。
 */
const Checkbox: React.FC<{
  checked: boolean;
  onChange: (checked: boolean) => void;
}> = ({ checked, onChange }) => {
  return (
    <span
      role="checkbox"
      aria-checked={checked}
      tabIndex={0}
      className={`cs-checkbox${checked ? " cs-checkbox--checked" : ""}`}
      onClick={(e) => {
        e.stopPropagation();
        onChange(!checked);
      }}
      onKeyDown={(e) => {
        if (e.key === " " || e.key === "Enter") {
          e.preventDefault();
          onChange(!checked);
        }
      }}
    >
      {checked && (
        <svg className="cs-checkbox__check" viewBox="0 0 12 12">
          <path
            d="M2.5 6.2l2.2 2.2L9.5 3.6"
            stroke="#fff"
            strokeWidth="1.8"
            fill="none"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      )}
    </span>
  );
};

export default Checkbox;
